import { MENU_ROUTES } from '../../Router/constants';

export const ABOUT_SUBMENU: MENU_ROUTES[] = [
  MENU_ROUTES.Documents,
  MENU_ROUTES.Standards,
  MENU_ROUTES.Other,
];

export const NAVIGATION_MENU: MENU_ROUTES[] = [
  MENU_ROUTES.Home,
  MENU_ROUTES.Projects,
  // MENU_ROUTES.News,
  MENU_ROUTES.About,
  // MENU_ROUTES.Cooperation,
  // MENU_ROUTES.Contact,
  MENU_ROUTES.Reports,
  MENU_ROUTES.Donate,
];

export const NAVIGATION_FOOTER_MENU: MENU_ROUTES[] = [
  MENU_ROUTES.Home,
  MENU_ROUTES.Projects,
  // MENU_ROUTES.NewsAndEvents,
  MENU_ROUTES.About,
  // MENU_ROUTES.Cooperation,
  // MENU_ROUTES.Contact,
  MENU_ROUTES.UserAgreement,
  MENU_ROUTES.Reports,
  MENU_ROUTES.Donate,
];
